module.exports = __webpack_public_path__ + "static/bharat_rural_expo-06452bfda73d9fe650ab7c1328443190.png";